import { render, staticRenderFns } from "./NavigationAuthButtons.vue?vue&type=template&id=04fcdd22&"
import script from "./NavigationAuthButtons.vue?vue&type=script&lang=js&"
export * from "./NavigationAuthButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports